// the detail is mapped to the broadcasts app format in legacyBroadcastBridge
$(document).on('click', '[broadcast-button]', function(this: JQuery) {
    const data = $(this).attr('t-data');

    if (!data) return;

    document.dispatchEvent(new CustomEvent('openBroadcast', {
        detail: JSON.parse(data),
    }));
});
